export default __webpack_public_path__ + "static/media/FeverPoles_08.19bcd70c.png";